<template>
  <div class="create-account">
    <div class="create-account__wrap">
      <form method="post" @submit.prevent="submit">
        <header-text :label="$t('account')" :title="$t('create_account')" />
        <div class="scroll-wrapper">
          <div class="create-account__scroll-wrap">
            <field-input
              v-model="$v.form.username.$model"
              :label="$t('username')"
              name="username"
              :v="$v.form.username"
            />
            <field-input
              v-model="$v.form.email.$model"
              :label="$t('email')"
              name="email"
              :v="$v.form.email"
            />
            <field-input
              v-model="$v.form.password.$model"
              :label="$t('password')"
              name="password"
              type="password"
              :v="$v.form.password"
            />
            <field-input
              v-model="$v.form.confirmPassword.$model"
              :label="$t('confirm_password')"
              name="confirmPassword"
              type="password"
              :v="$v.form.confirmPassword"
            />
            <checkbox-toggle
              v-model="$v.form.tos.$model"
              label="Agreement"
              name="tos"
              :v="$v.form.tos"
            >
              {{ $t("agree_terms") }}
              <a href="https://larian.com/tos" target="_blank">{{
                $t("read_terms")
              }}</a
              >&nbsp;
              <a href="https://larian.com/privacy" target="_blank">{{
                $t("read_privacy_policy")
              }}</a>
            </checkbox-toggle>

            <checkbox-toggle
              v-model="$v.form.newsletter.$model"
              label="Agreement"
              name="newsletter"
            >
              {{ $t("subscribe_newsletter") }}
            </checkbox-toggle>

            <div class="buttons">
              <r-button-submit
                :label="$t('create_account')"
                id="create-submit"
                color="white"
                pad-a="click"
                pad-right="go:#create-back"
              />
              <button-back
                :label="$t('back')"
                id="create-back"
                color="white"
                pad-start
                pad-a="click"
                pad-left="go:#create-submit"
                @click="$emit('accountLogin')"
              />
            </div>

            <required-label />
          </div>
        </div>
      </form>
    </div>

    <!-- <modal v-if="isModal" @close="isModal = false">
      <header-text
        :label="$t('larian_account')"
        :title="$t('license_agreement')"
        color="dark"
      />
      <div class="modal-content" v-html="$t('license')"></div>
      <template v-slot:buttons class="buttons">
        <a
          href="#"
          class="btn --large --yellow"
          @click.prevent="isModal = false"
        >
          <span class="btn__stroke"></span>
          <span class="btn__label">{{ $t("continue") }}</span>
        </a>
      </template>
    </modal> -->
  </div>
</template>

<script>
import {
  required,
  // requiredIf,
  minLength,
  maxLength,
  alphaNum,
  sameAs,
  email
} from "vuelidate/lib/validators";
import Gamepad from "@/utils/gamepadInit";

function passwordValidation(password) {
  // Minimum of 1 Uppercase Letter
  if (false === /[A-Z]/.test(password)) return false;

  // Minimum of 1 Number
  if (false === /[0-9]/.test(password)) return false;

  // Minimum of 1 lowercave letter
  if (false === /[a-z]/.test(password)) return false;

  // Minimum of 6 Characters
  if (false === password.length >= 8) return false;

  return true;
}

export default {
  data() {
    return {
      isModal: false,
      form: {
        username: undefined,
        email: undefined,
        password: undefined,
        confirmPassword: undefined,
        tos: undefined,
        newsletter: undefined,
        captcha: process.env.VUE_APP_CAPTCHA
      },
      scrollOptions: {
        bar: {
          background: "#ffe176",
          onlyShowBarOnScroll: false,
          initialScrollY: 50,
          initialScrollX: 50,
          size: "8px",
          keepShow: true,
          opacity: 1
        }
      }
    };
  },

  computed: {
    passwordValidation(password) {
      // Minimum of 1 Uppercase Letter
      if (false === /[A-Z]/.test(password)) return false;

      // Minimum of 1 Number
      if (false === /[0-9]/.test(password)) return false;

      // Minimum of 1 lowercave letter
      if (false === /[a-z]/.test(password)) return false;

      // Minimum of 8 Characters
      if (false === password.length >= 8) return false;

      return true;
    }
  },

  validations: {
    form: {
      username: {
        required,
        alphaNum,
        minLength: minLength(3),
        maxLength: maxLength(30)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        passwordValidation
      },
      confirmPassword: {
        sameAsPassword: sameAs("password")
      },
      newsletter: {},
      tos: {
        required,
        sameAs: sameAs(() => true)
      }
    }
  },
  mounted() {
    this.form.use = this.$route.query.use;
    Gamepad();
  },
  methods: {
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("submitCreate", this.form);
      }
    },
    onCaptchaSuccess(token) {
      this.form.captcha = token;
    },
    onCaptchaExpired() {
      this.form.captcha = null;
    },
    onCaptchaError() {
      this.form.captcha = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.create-account {
  // width: 500px;
  // margin: 0 auto;
  // height: 300px;
  // height: 53vw;
  height: 100%;
  position: relative;

  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 6px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(255, 225, 118);
    border-radius: 6px;
    cursor: pointer;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(255, 225, 118);
  }

  &__wrap {
    height: 100%;
    // padding-bottom: 120px;
  }

  .labels {
    justify-content: flex-end;
    margin-top: 10px;
  }

  form {
    height: 100%;
  }
}

.buttons {
  margin-top: 30px;
}

.errors > div {
  color: #ff0000;
  font-size: 11px;
  margin-top: 10px;
}

.modal-inner {
  max-height: 500px;
}

.modal__body {
  width: 100%;
  height: auto;
}

.scroll-wrapper {
  height: calc(100% - 83px);
  overflow-y: auto;
}
</style>
